import { render, staticRenderFns } from "./MA11Labels.vue?vue&type=template&id=038d9763&scoped=true&"
import script from "./MA11Labels.vue?vue&type=script&lang=js&"
export * from "./MA11Labels.vue?vue&type=script&lang=js&"
import style0 from "./MA11Labels.vue?vue&type=style&index=0&id=038d9763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d9763",
  null
  
)

export default component.exports